// extracted by mini-css-extract-plugin
export var statItem = "_c5-1";
export var statsRow = "_c5-0";